import React, { useMemo, useState, useEffect } from "react";
import { Container, Row, Col} from "reactstrap";
import { connect, useDispatch } from "react-redux";
import LeftColumn from "../../components/Messages/LeftColumn";
import Messages from "../../components/Messages/Messages";
import { setActiveThread } from "../../redux/Messages/ActiveThreadAction";
import Plans from './Plans';
import { useLocation } from "react-router-dom";
import { ensureDMThread } from "redux/Messages/ThreadsAction";

function PrepTalk({ userDetails, presenceItems, activeThread, setActiveThread }) {

  const dispatch = useDispatch();
  const location = useLocation();

  const meEmail = userDetails?.email?.toLowerCase();
  const presenceMap = useMemo(
    () => Object.fromEntries((presenceItems || []).map(p => [p.email, p])),
    [presenceItems]
  );

  const [activeTab, setActiveTab] = useState("chats");
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const coachEmail = params.get("coach");
    

    const openOrCreateThread = async () => {
      
      const threadKey = await dispatch(ensureDMThread({ aEmail: meEmail, bEmail: coachEmail }));

      if (threadKey) {
        
        setActiveThread({ id: threadKey, threadKey, participantsEmails: [meEmail, coachEmail] });

        window.history.replaceState({}, "", "/client/prep-talk");
      }
    };

    openOrCreateThread();

  }, [location.search]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }, 800);

    return () => clearTimeout(timeout);
  }, [activeThread]);

  return (
    <>
      <div className="header bg-gradient-info  pb-8  pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
           
          </div>
        </Container>
      </div>
      {/* <Container className="mt--7" fluid> */}
      <Container fluid className="msgr mt--8  py-2 mb-5" >
      {/* Mobile */}
      <div className="d-lg-none  mb-2" >
        {/* <Nav className="msgr-tab">
          {["chats", "people", "chat"].map(tab => (
            <NavItem key={tab}>
              <NavLink
                href="#"
                className={activeTab === tab ? "active" : ""}
                onClick={e => {
                  e.preventDefault();
                  setActiveTab(tab);
                }}
              >
                {tab === "chats" ? "Chats" : tab === "people" ? "People" : "Chat"}
              </NavLink>
            </NavItem>
          ))}
        </Nav> */}
        {activeTab != "chats" && <button className="btn btn-warning" onClick={e => {
                  e.preventDefault();
                  setActiveTab("chats");
                }} ><i class="fas fa-arrow-left"></i> Threads</button>}
        
      </div>

      <div className="d-lg-none">
        {activeTab !== "chat" ? (
          
          <div className="card msgr-h-viewport msgr-threads shadow">
            <div className="card-body p-0 d-flex flex-column">
              <LeftColumn
                meEmail={meEmail}
                presenceMap={presenceMap}
                onOpenThread={(t) => {
                  setActiveThread(t);
                  setActiveTab("chat");
                }}
              />
            </div>
          </div>

        ) : (
          <div className="h-100">
            <div className="card msgr-h-viewport shadow">
              <div className="card-body p-0 d-flex flex-column">
                {activeThread ? (
                  <Messages thread={activeThread} />
                ) : (
                  <div className="p-4 text-center text-muted font-weight-bolder">Select a conversation.</div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Desktop */}
      <Row className="g-2 d-none d-lg-flex" style={{ height: "calc(100vh - 64px)" }}>
        <Col xl="4"  lg="5" className="h-100">
          <div className="card msgr-h-viewport msgr-threads shadow">
            <div className="card-body p-0 d-flex flex-column">
              <LeftColumn
                meEmail={meEmail}
                presenceMap={presenceMap}
                onOpenThread={(t) => setActiveThread(t)}
              />
            </div>
          </div>
        </Col>
        <Col  className="h-100">
          <div className="card msgr-h-viewport shadow">
            <div className={"card-body p-0 d-flex flex-column "+ (!activeThread && "justify-content-center")}>
              {activeThread ? (
                <Messages thread={activeThread} />
              ) : (
                <div className="p-4 text-center text-muted font-weight-bolder">Select a conversation.</div>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
    <Plans ></Plans>          
    </>
  );
}

export default connect(
  (s) => ({
    userDetails: s.loginAuth.userDetails,
    presenceItems: s.presence.items,
    activeThread: s.activeThread, // ✅ from Redux
  }),
  { setActiveThread }
)(PrepTalk);